// src/components/HelpTooltip.jsx
import React from 'react';
import { Tooltip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Snippet = styled('pre')(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  fontSize: 11,
  margin: 0,
  whiteSpace: 'pre-wrap',
}));

/**
 * 
 * @param {{
 *   title: React.ReactNode,
 *   snippet?: string
 * }} props
 */
export default function HelpTooltip({ title, snippet }) {
  return (
    <Tooltip
      arrow
      title={
        <Box>
          {title}
          {snippet && <Snippet>{snippet}</Snippet>}
        </Box>
      }
    >
      <InfoOutlinedIcon fontSize="small" sx={{ cursor: 'pointer', ml: 0.5 }} />
    </Tooltip>
  );
}
